module.exports = require('lodash/isString')
